import { KYMW6800Component } from './kymw6800.component';


/**
 * ECカテゴリ変換マスタ一覧画面の値を管理するクラス
 *
 * @export KYMW6800Model
 * @class KYMW6800Model
 */
export class KYMW6800Model {

  kymw6800Component: KYMW6800Component;

  // カテゴリ一覧データ
  public categoryInfoList: Array<any> = new Array<any>();
  // カテゴリ変換マスタ一覧データ
  public categoryConvList: Array<any> = new Array<any>();

  // 商品マスタ区分
  // 変更箇所：対象から "承認マスタ" を外すためコメントアウト
  //public GOODS_NUMBER: string = <string>'0';
  // 商品企画マスタ区分
  public PLAN_GOODS_NUMBER: string = <string>'2';
  // 在庫限定区分
  public STOCK_LIMIT_FLG: string = <string>'3';

  // ラジオボタン（2：商品企画マスタ、3：在庫限定）
  public radioGroup: string = <string>this.PLAN_GOODS_NUMBER;

  // 処理区分(0：登録)
  public PROCES_DIV_REGIST: string = <string>'0';
  // 処理区分(1：更新)
  public PROCES_DIV_UPDATE: string = <string>'1';
  // 番号未設定
  public UNDEFINED_NUMBER: string = <string>'0';
  // コード値未設定
  public UNDEFINED_CODE: string = <string>'*';

  // 共通
  public categoryDiv: string = <string>'';                                      // カテゴリ区分
  public categoryCode: string = <string>'';                                     // カテゴリコード
  public stockLimitFlg: string = <string>'';                                        // 在庫限定

  // サーバーデータ仮入れ
  private dbItems: any = null;

  /**
   *
   *
   * @param {*} data
   * @memberof KYMW6800Model
   */
  public setTreeView(data: any) {
    // DB取得値からプロパティを選んで自身にコピーする
    this.dbItems = data.Category;
    this.categoryInfoList = [];

    // カテゴリ一覧初期化処理  第１階層カテゴリデータの初期化処理
    for (let i = Number(0); i < this.dbItems.length; i++) {

      this.categoryInfoList.push(this.dbItems[i]);
      this.categoryInfoList[i].CategoryName = this.dbItems[i].CategoryCode + ':'
        + this.dbItems[i].CategoryName;

      // 子カテゴリがあった場合 第２階層カテゴリデータの初期化処理
      if ('Category' in this.dbItems[i]) {
        const list2: Array<any> = new Array<any>();                             // 子カテゴリを仮に入れる配列を定義する
        for (let j = Number(0); j < this.dbItems[i].Category.length; j++) {
          // ソートにより、子カテゴリを取得し、仮置き配列に追加する
          list2.push(this.dbItems[i].Category[j]);
          list2[j].CategoryName = this.dbItems[i].Category[j].CategoryCode + ':'
            + this.dbItems[i].Category[j].CategoryName;

          // 孫カテゴリがあった場合 第３階層カテゴリデータの初期化処理
          if ('Category' in this.dbItems[i].Category[j]) {
            const list3: Array<any> = new Array<any>();                         // 孫カテゴリを仮に入れる配列を定義する
            for (let k = Number(0); k < this.dbItems[i].Category[j].Category.length; k++) {
              // ソートにより、孫カテゴリを取得し、仮置き配列に追加する
              list3.push(this.dbItems[i].Category[j].Category[k]);
              list3[k].CategoryName = this.dbItems[i].Category[j].Category[k].CategoryCode + ':'
                + this.dbItems[i].Category[j].Category[k].CategoryName;
            }
            // 第２階層カテゴリへ第３階層配列を追加
            // list2[j].Category = [];
            list2[j].Category = list3;
          }
        }
        // 第１階層カテゴリへ第２階層配列を追加
        this.categoryInfoList[i].Category = list2;
      }
    }

    // ツリーの再描画を行う
    this.kymw6800Component.tre_Category.loadTree();
  }

  /**
   * カテゴリ関連マスタ取得結果
   *
   * @param {*} serverData ユーザーリストのサーバ取得データ
   * @returns {void}
   * @memberof KYMW6800Model
   */
  public getGoodsCategory(serverData: any): void {
    // 検索結果のチェック
    if (!serverData.Category || !serverData.Category.List) {                 // 該当データなしの場合

      // カテゴリ変換マスタ一覧データの初期化
      this.categoryConvList = [];

      // フォーカス設定
      this.kymw6800Component.btn_Display.nativeElement.focus();

      // 処理復帰
      return;
    } else {                                                                    // 該当データありの場合
      // 検索結果を変換
      this.categoryConvList = serverData.Category.List;

      // カテゴリ変換マスタ一覧の有効化
      this.kymw6800Component.dtg_CategoryConvList.imeEnabled = true;
    }
  }

  /**
   * 更新イベント用VO取得
   *
   * @returns {*}
   * @memberof KYMW6800Model
   */
  public getUpdateVo(): any {
    const vo: any = new Object();

    // 商品マスタ選択の場合
    // 商品マスタを外して在庫限定を追加したため修正
    /* if (this.radioGroup === this.GOODS_NUMBER) {
      // チェック処理なし
      vo.categoryDiv = this.GOODS_NUMBER;
    } else */ 
     if (this.radioGroup === this.PLAN_GOODS_NUMBER) {
      // 商品企画マスタ選択の場合
      vo.categoryDiv = this.PLAN_GOODS_NUMBER;
    } else if (this.radioGroup === this.STOCK_LIMIT_FLG) {
      // 在庫限定選択の場合
      vo.categoryDiv = this.STOCK_LIMIT_FLG;
    }

    // ツリーよりカテゴリコードを取得
    const selectedItem: any = this.kymw6800Component.tre_Category.selectedItem;
    vo.categoryCode = selectedItem.CategoryCode;

    // 更新イベント用VOを返却
    return vo;
  }

  /**
   * 初期化
   *
   * @memberof KYMW6800Model
   */
  public clean(): void {
    // カテゴリ一覧データの初期化
    this.categoryInfoList = [];

    // カテゴリ変換マスタ一覧データの初期化
    this.categoryConvList = new Array<any>();
  }

  /**
   * 引数のオブジェクトをArrayCollectionに変換して返却する。
   * （nullオブジェクト対応版：nullの場合、空のArreyCollectionを返却する）
   *
   * @param {*} obj
   * @returns {Array<any>}
   * @memberof KYMW6800Model
   */
  public convObjectToArrayCollection(obj: any): Array<any> {
    let retList: Array<any> = new Array<any>();
    if (obj != null) {
      retList = obj;
    }
    return retList;
  }

}
